import {useEffect, useState} from "react";
import {useRouter} from "next/router";
import FilterBase from "@/components/filters/FilterBase";
import ButtonComponent from "@/components/ui/buttons/ButtonComponent";
import styles from "@/components/filters/BodyStyleFilter.module.css";
import {authenticatedFetchAPI} from "@/pages/api/clearwattApi";

const BodyStyleFilter = () => {
  const router = useRouter();
  const buttonName = 'Body Style';
  const filterName = 'body_style';
  const [bodyStyles, setBodyStyles] = useState([]);
  const [selectedStyles, setSelectedStyles] = useState([]);

  /*useEffect(() => {
    authenticatedFetchAPI("/api/bodystyles")
      .then(data => {
        setBodyStyles(data);
      })
      .catch(error => {
        console.error("Error fetching body styles:", error);
      });
  }, []);*/

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = `${process.env.NEXT_PUBLIC_CLEARWATT_BASE_API}/vehicles/body_styles/`;
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setBodyStyles(data);
      } catch (error) {
        console.error('Error fetching body styles:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (router.query.body_style) {
      setSelectedStyles(router.query.body_style.split(','));
    }
  }, [router.query.body_style]);

  const handleStyleClick = (style) => {
    setSelectedStyles(prev => prev.includes(style) ? prev.filter(s => s !== style) : [...prev, style]);
  };

  const handleFilterClick = () => {
    const {query} = router;
    router.push({
      pathname: router.pathname,
      query: {...query, body_style: selectedStyles.join(',')},
    });
  };

  return (
    <FilterBase buttonName={buttonName}>
      <div className={styles.filters}>
        <div className={styles.subFilters}>
          <div className={styles.inputs}>
            {bodyStyles.map(styleObj => (
              <div
                key={styleObj.misc_body}
                className={`${styles.style} ${selectedStyles.includes(styleObj.misc_body) && styles.selected}`}
                onClick={() => handleStyleClick(styleObj.misc_body)}
              >
                {styleObj.misc_body}
                {selectedStyles.includes(styleObj.misc_body) && (
                  <span className={styles.cw_filter__badge__icon}>✕</span>
                )}
              </div>
            ))}
          </div>
          <div className={styles.controls}>
            <ButtonComponent
              icon="🔍"
              iconPosition="left"
              text={`Filter ${selectedStyles.length > 0 ? `(${selectedStyles.length})` : ""}`}
              onClick={handleFilterClick}
            />

          </div>
        </div>
      </div>
    </FilterBase>
  );
};

export default BodyStyleFilter;
